import React, { lazy } from "react";

const DeleteAccount = lazy(() => import("../../modules/delete-account"));

export const deleteAccountRoute = [
  {
    path: "delete-account",
    element: <DeleteAccount />
  }
];
